// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/services/materialDispatchService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";


// =============================================================================
// GET DISPATCH LIST
// =============================================================================

export async function getDispatchList(
  params = {}
) {

  const response =
    await axiosClient.get(

      "/api/pms/material-dispatch/list",

      {
        params
      }
    );

  return response.data;
}


// =============================================================================
// CREATE DISPATCH HEADER
// =============================================================================

export async function createDispatchHeader(
  payload
) {

  const response =
    await axiosClient.post(

      "/api/pms/material-dispatch/create",

      payload
    );

  return response.data;
}


// =============================================================================
// GET DISPATCH DETAIL
// =============================================================================

export async function getDispatchDetail(
  dispatchId
) {

  const response =
    await axiosClient.get(

      `/api/pms/material-dispatch/${dispatchId}`
    );

  return response.data;
}

// =============================================================================
// ADD DISPATCH LINE
// =============================================================================

// =============================================================================
// ADD DISPATCH LINE
// =============================================================================

export async function addDispatchLine(
  payload
) {

  const response =
    await axiosClient.post(

      `/api/pms/material-dispatch/${payload.dispatch_header_id}/add-line`,

      payload
    );

  return response.data;
}
// =============================================================================
// SUBMIT DISPATCH
// =============================================================================

export async function submitDispatch(
  dispatchId
) {

  const response =
    await axiosClient.post(

      `/api/pms/material-dispatch/${dispatchId}/submit`
    );

  return response.data;
}

// =============================================================================
// APPROVE DISPATCH
// =============================================================================

export async function approveDispatch(
  dispatchId,
  payload
) {

  const response =
    await axiosClient.post(

      `/api/pms/material-dispatch/${dispatchId}/approve`,

      payload
    );

  return response.data;
}